import FilterItem from '@/components/PCP/FilterItem'

interface StaticFilterSectionProps {
  title: string
  item: string
}

const StaticFilterSection: React.FC<StaticFilterSectionProps> = ({ title, item }) => {
  return (
    <div>
      <h3 className='font-quicksand font-bold text-sm mb-[10px]'>{title}</h3>
      <FilterItem index={0} label={item} onSelect={() => {}} active={true} />
    </div>
  )
}

export default StaticFilterSection
